import React from 'react';
import ReactDOM from 'react-dom';
import CssBaseline from '@material-ui/core/CssBaseline';
import { ThemeProvider } from '@material-ui/core/styles';
import { StoreProvider } from './store/useStore'
import App from './App';
import theme from './theme';
import * as serviceWorker from './serviceWorker';
import './global.css';
//import './DocViewer.css'

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <StoreProvider >
        <App />
      </StoreProvider>
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA

// Track if we've already reloaded to prevent reload loops
let refreshing = false;

// Listen for controller change (happens when new service worker activates)
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (refreshing) return;
    refreshing = true;
    console.log('[App] New service worker controller, reloading...');
    window.location.reload();
  });
}

serviceWorker.register({
  onUpdate: registration => {
    console.log('[App] New version available!');
    
    // Show user-friendly notification
    const userConfirmed = window.confirm(
      'New version of admin.gigsdata.com available! Click OK to update now.'
    );
    
    if (userConfirmed && registration && registration.waiting) {
      // Tell the waiting service worker to skip waiting
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
      // The controllerchange event above will handle the reload
    }
  },
  onSuccess: registration => {
    console.log('[App] Service worker registered successfully');
  }
});

